import { type CreateControllerFn } from '@wix/yoshi-flow-editor';

import { globalAppState } from '../../../services/global-app-state';
import { getLoginBarMenu } from '../../../utils/login-bar-menu';
import { initBuyAgain } from '../shared/buy-again';
import { addLoginHandler } from './handlers';
import { getContext } from './viewer-controller/context';

export const controllerMAV2: CreateControllerFn = async (props) => {
  const { contextProps, contextServices } = getContext(props);
  const { environment } = contextProps.flowAPI;
  const { user } = contextProps.wixCodeApi;
  const { stateService, menuService } = contextServices;
  const shouldRenderMenu = user.currentUser.loggedIn && environment.isViewer;

  return {
    async pageReady() {
      if (shouldRenderMenu) {
        await stateService.fetchInitialData();
        menuService.initializeMenuItems();
      }

      addLoginHandler(contextProps, contextServices);

      globalAppState.setMembersLoginWidgets([
        ...globalAppState.getMembersLoginWidgets(),
        ...getLoginBarMenu(contextProps.$w),
      ]);

      await initBuyAgain(contextProps);
    },
  };
};
